// data/languages/Cote/categories/salutations.ts

import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {
    // Salutations de base et temporelles
    'ⲭⲉⲣⲉ (chere)': {
        translation: 'Salut / Réjouis-toi (salutation générale)',
        translationEn: 'Hi / Rejoice (general greeting)',
        illustration: '👋'
    },
    'ⲭⲉⲣⲉ ⲧⲟⲟⲩⲉ (chere tooue)': {
        translation: 'Bonjour (le matin)',
        translationEn: 'Good morning',
        illustration: '🌅'
    },
    'ⲛⲟϥⲣⲓ ⲉϩⲟⲟⲩ (nofri ehoou)': { // CORRECTION : Remplacé ⲭⲉⲣⲉ ⲙⲉⲣⲉ
        translation: 'Bon jour',
        translationEn: 'Good day',
        illustration: '☀️'
    },
    'ⲭⲉⲣⲉ ⲣⲟⲩϩⲉ (chere rouhe)': {
        translation: 'Bonsoir',
        translationEn: 'Good evening',
        illustration: '🌆'
    },
    'ⲛⲟϥⲣⲓ ⲉϫⲱⲣϩ (nofri ejôrh)': {
        translation: 'Bonne nuit',
        translationEn: 'Good night',
        illustration: '🌙'
    },

    // Au revoir et Paix
    'ⲟⲩϫⲁⲓ (oujai)': {
        translation: 'Au revoir / Adieu (simple)',
        translationEn: 'Goodbye / Farewell (simple)',
        illustration: '✌️'
    },
    'ⲙⲟⲟϣⲉ ϧⲉⲛ ⲟⲩϩⲓⲣⲏⲛⲏ (mooshe qen ouhirini)': {
        translation: 'Va en paix (Au revoir formel)',
        translationEn: 'Go in peace (formal goodbye)',
        illustration: '🕊️'
    },

    // Remerciements et excuses
    'ϣⲉⲡϩⲙⲟⲧ (shephmot)': {
        translation: 'Merci',
        translationEn: 'Thank you',
        illustration: '🙏'
    },
    'ϣⲉⲡϩⲙⲟⲧ ⲉⲙⲁϣⲱ (shephmot emashô)': {
        translation: 'Merci beaucoup',
        translationEn: 'Thank you very much',
        illustration: '🙏'
    },
    'ⲁⲣⲓⲡⲁⲙⲉⲩⲓ (aripameui)': {
        translation: 'S\'il vous plaît / Souviens-toi de moi',
        translationEn: 'Please / Remember me',
        illustration: '🤲'
    },
    'ⲭⲱ ⲛⲏⲓ ⲉⲃⲟⲗ (chô nêi ebol)': {
        translation: 'Pardon / Excusez-moi (litt. Pardonne-moi)',
        translationEn: 'Sorry / Excuse me (lit. Forgive me)',
        illustration: '🙇'
    },

    // Réponses de base
    'ϩⲁϩ (hah)': {
        translation: 'Oui',
        translationEn: 'Yes',
        illustration: '👍'
    },
    'ⲁⲛ (an)': {
        translation: 'Non',
        translationEn: 'No',
        illustration: '👎'
    },
    'ⲉⲛⲉϩ (eneh)': {
        translation: 'Bienvenue',
        translationEn: 'Welcome',
        illustration: '🤝'
    }
};

export default salutations;
